import { createSlice } from '@reduxjs/toolkit';
import type { BuyImmunityResponse, ImmunityError } from '../api/buyImmunity.types';
import { buyImmunity } from './buyImmunity.thunk';



interface ImmunityState {
  loading: boolean;
  error: ImmunityError | null;
  lastPurchase: BuyImmunityResponse | null;
}

const initialState: ImmunityState = {
  loading: false,
  error: null,
  lastPurchase: null,
};

const immunitySlice = createSlice({
  name: 'immunity',
  initialState,
  reducers: {
    clearImmunityState: (state) => {
      state.error = null;
      state.lastPurchase = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(buyImmunity.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(buyImmunity.fulfilled, (state, action) => {
      state.loading = false;
      state.lastPurchase = action.payload;
    });
    builder.addCase(buyImmunity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || {
        code: 500,
        message: 'Unknown immunity purchase error',
      };
    });
  },
});

export const { clearImmunityState } = immunitySlice.actions;
export default immunitySlice.reducer;